function updateSlickListHeight() {
  const slickList = document.querySelector('.thumbnails-wrapper');
  const prodImg = document.querySelector('.prod-large-img');
  const existingStyle = document.getElementById('slick-style');

  if (existingStyle) existingStyle.remove();

  if (slickList && prodImg && window.innerWidth > 1050) {
    const height = prodImg.offsetHeight;
    const style = document.createElement('style');
    style.id = 'slick-style';
    style.textContent = `
      .thumbnails-wrapper .slick-list {
        max-height: ${height}px !important;
        overflow: hidden !important;
      }
    `;
    document.head.appendChild(style);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(updateSlickListHeight, 1000);
});

window.addEventListener('resize', () => {
  setTimeout(updateSlickListHeight, 1000);
});

document.querySelectorAll('.accordion-toggle')?.forEach(toggle => {
  toggle.addEventListener('click', () => {
    const item = toggle.closest('.accordion-item');
    const isOpen = item.classList.contains('active');

    // document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));

    if (!isOpen) {
      item.classList.add('active');
    }
    else{
      item.classList.remove('active');
    }
  });
});

document.querySelector('.desktop-review-widget')?.addEventListener('click', () => {
  const reviewDropdown = document.querySelector(".reveiw-dropdown-487");

  reviewDropdown.classList.add('active');
})

document.querySelector('.size-guide-trigger')?.addEventListener('click', () => {
  const sizechartDropdown = document.querySelector(".sizechart-dropdown-487");

  sizechartDropdown.classList.add('active');

  sizechartDropdown.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function formatAllJudgeMeRatings() {
    const ratingEls = document.querySelectorAll('.jdgm-rev-widg__summary-average');

    ratingEls.forEach((el) => {
      const match = el.textContent.match(/([\d.]+)\s*\/\s*5/);
      if (match) {
        const raw = parseFloat(match[1]);
        const rounded = Math.round(raw * 10) / 10;
        el.textContent = `${rounded.toFixed(1)} / 5`;
      }
    });
  }

  const interval = setInterval(() => {
    const found = document.querySelectorAll('.jdgm-rev-widg__summary-average');
    if (found.length > 0) {
      clearInterval(interval);
      formatAllJudgeMeRatings();
    }
  }, 500);
});

document.addEventListener("DOMContentLoaded", function () {
  const dataScript = document.getElementById("short-reviews-json-487");
  const sliderContainer = document.querySelector(".short-review-slider-container-487");
  const slider = document.querySelector(".short-review-slider-487");

  if (dataScript && slider) {
    const reviews = JSON.parse(dataScript.textContent);
    const slideLimit = parseInt(slider.dataset.slideshowCount) || 12;
    const slideSpeed = (parseInt(slider.dataset.slideshowSpeed) || 3) * 1000;

    if (reviews.length === 0) {
      sliderContainer.style.display = "none";
    } else {
      reviews.slice(0, slideLimit).forEach((review) => {
        const summary = review.summary || "";
        const customerName = review.customer_name || "Anonymous";
        const [rawFirst = "", rawLast = ""] = customerName.trim().split(" ");
        const firstName = rawFirst.charAt(0).toUpperCase() + rawFirst.slice(1).toLowerCase();
        const lastInitial = rawLast ? rawLast.charAt(0).toUpperCase() + "." : "";

        const fullName = lastInitial ? `${firstName} ${lastInitial}` : firstName;

        const combined = `${summary} - ${fullName}`;
        const combinedFirst = `${summary} - ${firstName}`;

        let displayName = '';
        if (combined.length <= 55) {
          displayName = fullName;
        } else if (combinedFirst.length <= 55) {
          displayName = firstName;
        } else {
          displayName = '';
        }

        const slide = document.createElement("div");
        slide.className = "short-review-slide";
        slide.innerHTML = `
          <div class="short-reviews-stars">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="short-review-text">
            <div class="short-review-text-487">“${summary}"</div>
            ${displayName ? `<div class="short-review-name-487">- ${displayName}</div>` : ''}
          </div>
        `;
        slider.appendChild(slide);
      });

      let current = 0;
      const slides = slider.querySelectorAll('.short-review-slide');

      function showSlide(index) {
        slides.forEach((el, i) => {
          el.style.opacity = i === index ? 1 : 0;
        });
      }

      showSlide(current);
      setInterval(() => {
        current = (current + 1) % slides.length;
        showSlide(current);
      }, slideSpeed);
    }
  }
});


// Highlight Color Logic
document.addEventListener("DOMContentLoaded", function () {
  function setImageColor(className) {
    const colorThief = new ColorThief();
    const img = document.querySelector(className);
    
    function getBestColor(palette) {
      const [domR, domG, domB] = palette[0];
      let best = palette[0];
      let maxColorfulness = 0;

      for (const [r, g, b] of palette) {
        const diff = Math.abs(domR - r) + Math.abs(domG - g) + Math.abs(domB - b);
        const isWashedOut = r + g + b > 550;

        if (diff <= 30 || isWashedOut) continue;

        const min = Math.min(r, g, b);
        const max = Math.max(r, g, b);
        const colorfulness =  ((max + min) * (max - min)) / max;

        if (colorfulness > maxColorfulness) {
          maxColorfulness = colorfulness;
          best = [r, g, b];
        }
      }

      return best;
    }

    function applyColor() {
      const palette = colorThief.getPalette(img, 8, 1);
      // const [r, g, b] = colorThief.getColor(img);
      const [r, g, b] = getBestColor(palette);
      const hex = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;

      const productContainer = document.querySelector('.product-container-487');
      const propertyExists = productContainer.style.getPropertyValue('--highlight-color');

      // let meta = document.querySelector('meta[name="theme-color"]');
      // if (!meta) {
      //   meta = document.createElement('meta');
      //   meta.name = 'theme-color';
      //   document.head.appendChild(meta);
      // }

      if (!propertyExists) {
        productContainer.style.setProperty('--highlight-color', hex);
        document.querySelector('.mobile-review-widget').style.setProperty('--highlight-color', hex);
        // meta.content = hex;
      }
      else{
        // meta.content = propertyExists;
      }
    }

    img.complete ? applyColor() : img.addEventListener('load', applyColor);
  }

  setImageColor('.color-thief-first-img-487 img');
});


// Splash effect
document.addEventListener("DOMContentLoaded", function () {
  function createSplashEffect(e) {
    const button = e.currentTarget;
    const rect = button.getBoundingClientRect();
    
    const originX = rect.width / 2;
    const originY = rect.height / 2;

    for (let i = 0; i < 8; i++) {
      const line = document.createElement("div");
      line.className = "splash-line";

      const angleDeg = i * 45 + (Math.random() * 15 - 7.5);
      const angleRad = angleDeg * (Math.PI / 180);

      let minStartRadius, travelDistance, lineHeight;

      if (window.innerWidth <= 768) {
        minStartRadius = 10;
        travelDistance = 30 + Math.random() * 6;
        lineHeight = 5 + Math.random() * 2;
      } else {
        minStartRadius = 10;
        travelDistance = 35 + Math.random() * 5;
        lineHeight = 6 + Math.random() * 2;
      }

      const spawnX = Math.cos(angleRad) * minStartRadius;
      const spawnY = Math.sin(angleRad) * minStartRadius;

      const dx = Math.cos(angleRad) * travelDistance;
      const dy = Math.sin(angleRad) * travelDistance;

      line.style.left = `${originX + spawnX}px`;
      line.style.top = `${originY + spawnY}px`;
      line.style.height = `${lineHeight}px`;

      const rotation = (Math.atan2(dy, dx) * 180 / Math.PI) - 90;
      line.style.setProperty("--rotation", `${rotation}deg`);
      line.style.setProperty("--dx", `${dx}px`);
      line.style.setProperty("--dy", `${dy}px`);

      button.appendChild(line);

      const randomDelay = Math.random() * 150;

      setTimeout(() => {
        line.classList.add("animate");
      }, randomDelay);

      setTimeout(() => {
        if (line.parentNode) {
          line.remove();
        }
      }, 500 + randomDelay);
    }
  }

  document.querySelectorAll(".swatch-grid-487 .swatch-element .swatchLbl")
    .forEach(btn => {
      btn.addEventListener("click", createSplashEffect);
    });

  document.querySelectorAll('.color-swatch-487 .swatchInput').forEach((input) => {
    input.addEventListener('change', function () {
      const label = this.nextElementSibling;

      if (this.checked) {
        label.classList.add('animate-border');

        setTimeout(() => {
          label.classList.remove('animate-border');
        }, 2000); // Stop animation after 2 seconds
      }
    });
  });
});


// PRODUCT COLOR SELECTOR
document.addEventListener('DOMContentLoaded', function() {
  const colorVariantsScript = document.querySelector('#color-selector-487');
  const container = document.getElementById('color-selector-container');
  
  if (!colorVariantsScript || !container) return;

  const isMinecraftStyle = container.classList.contains('color-swatch-minecraft-487');
  
  const colorVariantsRaw = JSON.parse(colorVariantsScript.textContent);
  const colorVariants = typeof colorVariantsRaw === 'string' ? JSON.parse(colorVariantsRaw) : colorVariantsRaw;
  
  const currentHandle = container.getAttribute('data-current-handle');
  
  // Utility function to check if a product variant is available
  // Uses Shopify's product JSON endpoint for real-time availability
  const checkProductAvailability = (handle, callback) => {
    fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(data => callback(data.available))
      .catch(() => callback(false));
  };
  
  const getCurrentSize = () => {
    const sizeInput = document.querySelector('input.swatchInput[name="option-0"]:checked');
    return sizeInput?.value || null;
  };
  
  // Handles navigation to different color variant while preserving size selection
  const switchColor = (targetHandle) => {
    const currentSize = getCurrentSize();
    const url = `/products/${targetHandle}${currentSize ? `?variant_size=${currentSize}` : ''}`;
    window.location.href = url;
  };
  
  const fragment = document.createDocumentFragment();
  
  colorVariants.forEach((variant) => {
    const isActive = variant.handle === currentHandle;
    const colorClass = variant.color.toLowerCase().replace(/\s+/g, '-');
    
    const swatchElement = document.createElement('div');
    swatchElement.className = `swatch-element ${isActive ? 'active' : ''}`;

    if (isMinecraftStyle) {
      swatchElement.innerHTML = `
        <label 
          class="swatchLbl color swt${colorClass}"
        >
          <span style="background-color: ${variant.hex} !important; cursor: ${isActive ? 'default' : 'pointer'}; --swatch-color: ${variant.hex};"></span>
          <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="24.9082" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="23.2471" y="1.66016" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="21.5869" y="3.3208" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="19.9268" y="4.98145" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="18.2666" y="6.6416" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="16.6055" y="8.30225" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="14.9453" y="9.96289" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="13.2852" y="11.6226" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="11.623" y="13.2832" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="9.96289" y="14.9438" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="8.30176" y="16.6045" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="6.6416" y="18.2646" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="4.98145" y="19.9248" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="3.32129" y="21.5859" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect x="1.66016" y="23.2461" width="1.66042" height="1.66042" fill="currentColor"/>
            <rect y="24.9062" width="1.66042" height="1.66042" fill="currentColor"/>
          </svg>
        </label>
      `;
    } else {
      // Default color swatch (simple colored square with label text)
      swatchElement.innerHTML = `
        <label class="swatchLbl color swt${colorClass} ${isActive ? 'animate-border' : ''}"
          style="background-color: ${variant.hex} !important; cursor: ${isActive ? 'default' : 'pointer'}; --swatch-color: ${variant.hex};">
          ${variant.color.toUpperCase()}
        </label>
      `;
    }

    if (isActive) {
      const labelEl = swatchElement.querySelector('label');
      setTimeout(() => {
        labelEl.classList.remove('animate-border');
      }, 4000);

      const colorDisplay = document.querySelector('[data-selected-color]'); 
      if(colorDisplay) {
        colorDisplay.textContent = `${variant.color}`;
      }
    }
    
    if (!isActive) {
      swatchElement.addEventListener('click', () => switchColor(variant.handle), { passive: true });
      
      checkProductAvailability(variant.handle, (available) => {
        if (!available) {
          swatchElement.classList.add('soldout');
        }
      });
    }
    
    fragment.appendChild(swatchElement);
  });
  
  container.appendChild(fragment);
  
  // Handle URL parameter for size pre-selection (maintains size when navigating from other colors)
  // Use requestAnimationFrame for better timing than setTimeout
  requestAnimationFrame(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sizeFromUrl = urlParams.get('variant_size');
    
    if (sizeFromUrl) {
      const targetInput = document.querySelector(`input.swatchInput[name="option-0"][value="${sizeFromUrl}"]`);
      targetInput?.click(); // Use optional chaining
    }
  });
});


// PRICE FIX 
document.addEventListener("DOMContentLoaded", function () {
  const currency = document.querySelector('.site-currency')?.innerText.trim();

  const minecraftContainer = document.querySelector(".minecraft-price-container");

  if(minecraftContainer) {
    // document.querySelectorAll('.product-price-487 .money').forEach((el) => {
    //   let text = el.innerText.replace(/\s[A-Z]{3}$/, '').trim();
    //   text = text.replace(/\s+/g, '');
    //   el.innerHTML = `${text} <span class="price-currency-487">${currency}</span>`;
    // });

    document.querySelectorAll('.product-price-487 span:not(:has(.money))').forEach((el) => {
      let priceText = el.innerText.trim();
      priceText = priceText.replace(/\s+/g, '')
      if (priceText) {
        el.innerHTML = `${priceText} <span class="price-currency-487">${currency}</span>`;
      }
    });
  }
  else {
    document.querySelectorAll('.product-price-487 .money').forEach((el) => {
      let text = el.innerText.replace(/\s[A-Z]{3}$/, '').trim();
      text = text.replace(/\s+/g, '');
      el.innerHTML = `${text} ${currency}`;
    });
  }
});


// COlOR SWATCH UPDATE
document.addEventListener('DOMContentLoaded', function() {
  const colorDisplay = document.querySelector('[data-selected-color]');
  if (!colorDisplay) return;
  
  const colorSwatchContainer = document.querySelector('.color-swatch-487');
  const isMinecraftStyle = container.classList.contains('color-swatch-minecraft-487');
  if (!colorSwatchContainer) return;
  
  if(isMinecraftStyle) return;
  
  function updateColorDisplay() {
    const checkedInput = colorSwatchContainer.querySelector('.swatchInput:checked');
    colorDisplay.textContent = checkedInput ? checkedInput.value : '';
  }
  
  setTimeout(() => {
    updateColorDisplay();
  }, 2000);
  
  colorSwatchContainer.addEventListener('change', updateColorDisplay);
  
  colorSwatchContainer.addEventListener('click', function(e) {
    if (e.target.closest('.swatchLbl')) {
      setTimeout(updateColorDisplay, 50);
    }
  });
});


// PREORDER LOGIC
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  let currentForm = null;
  let currentVariantId = null;
  let modalOpen = false;

  const modal = document.getElementById('preorder-warning-modal');
  const dateEl = document.getElementById('preorder-dispatch-date');
  const closeBtn = document.getElementById('preorder-close');
  const checkbox = document.getElementById('preorder-acknowledge');
  const confirmBtn = document.getElementById('preorder-confirm');

  if (!modal || !dateEl || !checkbox || !confirmBtn) {
    // console.error('❌ Missing preorder modal elements');
    return;
  }

  modal.addEventListener('click', function (e) {
    if (e.target.classList.contains('preorder-modal-overlay')) {
      closeModal();
    }
  });

  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('.product-form__cart-submit');
      if (!btn || modalOpen) return;
      if (!btn.classList.contains('preorder-active')) return;

      const form = btn.closest('form[action*="/cart/add"]');
      if (!form) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId =
        form.querySelector('select[name="id"], input[name="id"]')?.value;

      const preOrderDate =
        window.variantPreOrderDateData?.[variantId];

      if (!variantId || !preOrderDate) return;

      currentForm = form;
      currentVariantId = variantId;

      openModal(preOrderDate);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      if (
        modalOpen &&
        e.target.matches('form[action*="/cart/add"]')
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  function openModal(dispatchDate) {
    modalOpen = true;

    const date = new Date(dispatchDate);
    dateEl.textContent = date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });

    checkbox.checked = false;
    confirmBtn.disabled = true;

    document.body.style.overflow = 'hidden';
    modal.style.display = 'flex';
  }

  function closeModal() {
    modalOpen = false;
    modal.style.display = 'none';
    document.body.style.overflow = '';

    currentForm = null;
    currentVariantId = null;
  }

  closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  checkbox.addEventListener('change', function () {
    confirmBtn.disabled = !this.checked;
  });

  confirmBtn.addEventListener('click', function () {
    if (!currentVariantId || !currentForm) return;

    const dispatchDate =
      window.variantPreOrderDateData[currentVariantId];

    const formData = new FormData();
    formData.append('id', currentVariantId);
    formData.append(
      'quantity',
      currentForm.querySelector('input[name="quantity"]')?.value || 1
    );
    const preorderType =
      confirmBtn.dataset.preorderType === 'backorder'
        ? '__backorder'
        : '__preorder';

    formData.append(`properties[${preorderType}]`, dispatchDate);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    })
      .then((r) => r.json())
      .then(() => {
        closeModal();
        document.dispatchEvent(new CustomEvent('cart:updated'));

        const cartDrawer = document.querySelector('.block-cart');
        if (cartDrawer) cartDrawer.classList.add('active');
      })
      .catch((err) => console.error('❌ Add failed:', err));
  });
});